// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"table_wrapper__h036e","table":"table_table__fDqIW"};